
//Jonahs' EditLabelDialog
//#region
EditLabelDialog = Ext.extend(Ext.Window, {

    title: '<%=L.__("EDIT_LABEL")%>' + ' - ',
    width: 400,
    height: 120,
    modal: true,

    initComponent: function () {

        var dlg = this;
        var doSubmit = function () {

            var name = dlg.findById('labelName');
            //var desc = dlg.findById( 'description' );

            if (dlg.callback) {
                dlg.callback(
                    dlg.table,
                    dlg.column,
                    name.getValue(),
                    ''//desc.getValue()
                );
            }

            dlg.close();

        };

        this.items = [
            {
                xtype: 'form',
                padding: 5,
                height: 55,
                labelAlign: 'right',
                id: 'frmEditLabel',
                keys: [
                    {
                        key: [Ext.EventObject.ENTER],
                        handler: doSubmit
                    },
                    {
                        key: [Ext.EventObject.ESC],
                        handler: function () {
                            dlg.close();
                        }
                    }
                ],
                items: [
                    {
                        xtype: 'textfield',
                        fieldLabel: ___('LABEL'),
                        anchor: '100%',
                        id: 'labelName'
                    }//,
                    //{
                    //	xtype: 'textfield',
                    //	fieldLabel: 'Description',
                    //	anchor: '100%',
                    //	id: 'description'
                    //}
                ]
            }
        ];
        this.bbar = {
            xtype: 'toolbar',
            items: [
                {
                    xtype: 'tbfill'
                },
                {
                    xtype: 'button',
                    text: ___('SAVE'),
                    tooltip: ___('SAVE'),
                    handler: doSubmit

                },
                {
                    xtype: 'button',
                    text: ___('CANCEL'),
                    tooltip: ___('CANCEL'),
                    handler: function () {
                        dlg.close();
                    }
                }
            ]
        };

        EditLabelDialog.superclass.initComponent.call(this);

    },

    listeners: {
        show: function () {
            this.findById('labelName').focus(true, 250);
        }
    },

    edit: function (table, column, labelText, callback) {

        this.table = table;
        this.column = column;
        this.labelText = labelText;
        this.callback = callback;

        var name = this.findById('labelName');
        name.setValue(labelText);

        this.setTitle(___("EDIT_LABEL") + " - " + column);
        this.show();

    }

});
//#endregion

//This is the dialog window for adding new UCI Values.
AddNewUCIValueDialog = Ext.extend(Ext.Window, {
    id: 'addNewValue',
    title: '',
    width: 400,
    height: 120,
    modal: true,
    initComponent: function () {
        var dlg = this;
        this.title = ___('ADD_NEW_COMBO_BOX_VALUE'),
            this.items = [
                {
                    xtype: 'form',
                    padding: 5,
                    height: 75,
                    labelAlign: 'right',
                    items: [{
                        xtype: 'textfield',
                        anchor: '100%',
                        fieldLabel: ___('NEW_VALUE'),
                        id: 'txtNewDataValue'
                    }]
                }];

        this.bbar = {
            xtype: 'toolbar',
            id: 'newDIalogToolbar',
            items: [
                { xtype: 'tbfill' },
                {
                    xtype: 'button',
                    text: ___('SAVE'),
                    tooltip: ___('SAVE'),
                    handler: function () {
                        //Create new record, add to existing grid, select from both existing and available.
                        var newValue = Ext.getCmp('txtNewDataValue').getValue().toString().trim(); // MTM-5828- Changes to trim empty spaces at the end
                        // MTM-5715
                        var newValuefirstUpper = newValue.charAt(0).toUpperCase() + newValue.substring(1).trim(); // To check for "Closed"
                        var newValueUpper = newValue.toUpperCase().trim(); // To check for "closed"   // MTM-5828- Changes to trim empty spaces at the end

                        // MTM-5828  - This was bit tricky hence checking for all the posiblities
                        if (columnGlobal == "cCallSheetStatus" && (newValue == ___('Closed') || newValuefirstUpper == ___('Closed') || (newValueUpper == 'CLOSED'))) // MTM - 5715 - To verify against all the the languages
                        {
                            Ext.Msg.alert(___('attention_title'), ___("CANNOT_ADD_STATUS_CLOSED"));
                            return;
                        }
                        // MTM-5715 Ends
                        Ext.Ajax.request({
                            url: '/UCI/AddNewAvailableComboData',
                            params: { value: newValue },
                            success: function (response) {
                                var newID = response.responseText;

                                var grid1 = Ext.getCmp('UCIExistingData');
                                var grid2 = Ext.getCmp('UCIAvailable');

                                var newRecord = new ComboRecord({ nUID: newID, cValue: newValue });

                                var position = grid1.store.getCount();
                                var otherPosition = grid2.store.getCount();

                                grid1.store.add(newRecord);
                                grid1.selModel.selectRow(position);

                                grid2.store.add(newRecord);
                                grid2.selModel.selectRow(otherPosition);

                                grid1.getView().focusRow(position);
                                grid2.getView().focusRow(otherPosition);

                            }
                        });
                        dlg.close();
                    }
                },
                {
                    xtype: 'button',
                    text: ___('CANCEL'),
                    tooltip: ___('CANCEL'),
                    handler: function () {
                        dlg.close();
                    }
                }
            ]
        };

        AddNewUCIValueDialog.superclass.initComponent.call(this);
    },
    // MTM-6047 - Code added to set the cursor to be in the text box when the Add New Combo Data screen opens
    listeners: {
        show: function () {
            this.findById('txtNewDataValue').focus(true, 250);
        }
    },
    // MTM-6047 Ends
    load: function () {
        this.show();
    }
});

//This defines the skeleton UCI Context Menu.
var UCIContextMenu = function () {
    this.onDeleteFN = Ext.emptyFn;
    this.clearAll = function () {

        function ClearAllItems() {
            //Get a reference to the existing grid
            var grid = Ext.getCmp('UCIExistingData');
            //Clear everything from the grid
            grid.store.each(function (record) {
                grid.store.remove(record);
            });
        }

        //Check if this item is a parent or something.
        var SelfGrid = Ext.getCmp('editComboD');
        if (SelfGrid.isParent) {
            //Then this is a parent of stuff.
            Ext.MessageBox.confirm(___("ARE_YOU_SURE"), ___("THE_ITEMS_SHARED_AMONGST_MULTIPLE_COMBO_BOXES_ARE_YOU_SURE_TO_CLEAR_ALL"),
                function (btn) {
                    if (btn == "yes")
                        ClearAllItems();
                });

        } else {
            ClearAllItems();
        }

    }
    this.addNew = function () {
        //Create a new AddNewItem window
        var dlg = new AddNewUCIValueDialog();
        //Show the window.
        dlg.load();
    }

    return new Ext.menu.Menu({
        style: { 'z-index': 9999999 },
        items: [{
            itemId: 'addNew',
            handler: this.addNew,
            text: ___('ADD_NEW_ITEM')
        }, {
            itemId: 'delete',
            handler: this.onDeleteFn,
            text: ___('DELETE_ITEM')
        }, {
            itemId: 'btnClearAll',
            handler: this.clearAll,
            text: ___('CLEAR_ALL_ITEMS'),
            listeners:
            {
                hide: function () {
                    this.doHide();
                    return this;
                }
            }
        }]
    });
}

function promptForTimeZoneId(callback) {
    var win = new Ext.Window({
        modal: true,
        width: 300,
        height: 150,
        layout: 'absolute',
        resizable: false,
        title: (___('SELECT_TIMEZONE')),
        items: [
            {
                xtype: 'displayfield',
                value: ___('TIMEZONE'),
                x: 20,
                y: 20
            },
            {
                xtype: 'combo',
                id: 'timeZones',
                x: 20,
                y: 40,
                forceSelection: true,
                editable: false,
                allowBlank: false,
                autoLoad: false,
                triggerAction: 'all',
                width: 240,
                displayField: 'DisplayName', //MTM-8553-Code changed to DisplayName
                valueField: 'Id',
                mode: 'remote',
                store: new Ext.data.XmlStore({
                    id: 'tzStore',
                    url: '/Grid/GetSystemTimeZoneIds',
                    record: 'TimeZone',
                    fields: ['DisplayName', 'Id'] //MTM-8553-Retrieving the displayname and id
                }),
                listeners: {
                    afterrender: function (self) {
                        var tz = Ext.getCmp('timeZones');
                        var store = tz.getStore();
                        store.load({
                            callback: function (r) {
                                var tz = Ext.getCmp('timeZones');
                                tz.setValue(r[0].get('Id'));
                            }
                        });
                    },
                    specialKey: function (field, el) {
                        if (el.getKey() == Ext.EventObject.ENTER) {
                            var button = Ext.getCmp('btnSelect');
                            button.focus();
                            return false;
                        }
                    }
                }
            },
            {
                xtype: 'button',
                id: 'btnSelect',
                text: ___('SUBMIT'),
                tooltip: ___('SUBMIT'),
                x: 190,
                y: 70,
                width: 70,
                height: 22,
                handler: function () {
                    var tz = Ext.getCmp('timeZones');
                    callback(tz.getValue());
                    win.close();
                }
            }
        ],
        listeners: {
            add: function () {
                var tz = Ext.getCmp('timeZones');
                if (tz !== undefined)
                    tz.focus(true, 200);
            }
        }
    });

    win.show();
    return win;
}

var ComboRecord = new Ext.data.Record.create([
    { name: 'nUID', mapping: 'nUID', allowBlank: false },
    { name: 'cValue', mapping: 'cValue', allowBlank: true }]);

var Columns = [{ dataIndex: 'nUID', hidden: true, id: 'nUID' }, { header: 'Combo Value', id: 'cVal', sortable: false, dataIndex: 'cValue' }];

var uciGrid = new Ext.extend(Ext.grid.GridPanel, {
    //columnWidth: '.5',
    colspan: 1,
    style: 'margin: 5px;width:300px',
    enableDragDrop: true,
    ddGroup: 'depGridDD',
    singleSelect: true,
    columns: Columns,
    autoExpandColumn: 'cVal',
    height: 335,
    loadMask: true,
    OnRightClick: function (grid, index) { /* Virtual Method. */ },
    DeleteFN: function (grid, index) { /* Virtual Delete Method. To be overriden. */ },
    loadValues: function () {
        if (this.store !== undefined)
            this.store.load();
    },
    renderContextMenu: function (grid, index, event) {
        event.stopEvent();
        if (!this.ContextMenu)
            this.ContextMenu = new UCIContextMenu();

        //Variables
        var text = ___("DELETE") + " ";
        var itemCount = grid.selModel.getCount();
        var hideDeleteItem = false;

        //Handles
        var clearItem = this.ContextMenu.getComponent('btnClearAll');
        var deleteItem = this.ContextMenu.getComponent('delete');

        //Initialize Settings
        clearItem.show();

        if (index === undefined && itemCount === 0) {
            //If the index is undefined, we are not clicking a row. So don't
            //bother with the delete.
            deleteItem.hide();
            hideDeleteItem = true;
        } else if (itemCount > 1) {
            //If we get here, it means that multiple items are selected.
            //but nothing on a row.
            text += "(" + itemCount + ") Items.";
        } else if (itemCount === 1 || index !== undefined) {
            //If we get here, they selected a single row.
            //Get the index of the selected row.
            if (index == undefined)
                index = grid.store.indexOf(grid.getSelectionModel().getSelected());

            //Get a reference to the selected row's item value.
            var itemName = grid.store.getAt(index).get('cValue');

            //Update the context items text property.
            text += "Item '" + itemName + "'";

            //Select the row in question.
            grid.selModel.selectRow(index);
        }

        if (!hideDeleteItem) {
            deleteItem.setHandler(function () { grid.DeleteFN(grid, index); });
            deleteItem.setText(text);
            deleteItem.show();
            deleteItem.enable();
        }

        //Bubble the OnRightClick event. 
        grid.OnRightClick(grid, index);

        this.ContextMenu.showAt(event.getXY());
    },
    listeners:
    {
        click: function (event) {
            if (event.getTarget(".x-grid3-row") !== null || event.getTarget(".x-grid3-hd") !== null) return;
            this.getSelectionModel().clearSelections();
        },
        containercontextmenu: function (grid, event) {
            grid.renderContextMenu(grid, undefined, event);
        },
        rowcontextmenu: function (grid, index, event) {
            grid.renderContextMenu(grid, index, event);
        },
        render: function (grid) {
            for (var i = 0, l = grid.columns.length; i < l; i++) {
                if (grid.columns[i].id == 'cVal') {
                    grid.columns[1].header = ___('Combo Value');
                    break;
                }
            }
        },
        destroy: function (event) {
            if (this.menu)
                this.menu.destroy();
        }
    }
});

var columnGlobal = undefined; // MTM-5715 -  Added global variable to store the columnName
var tableGlobal = undefined;

//A variable for keeping track of a generic warning message used multiple places.
var relationalWarning = '';

function getFacilitesWithCustomizedData(callback) {
    var mainGrid = Ext.getCmp('editComboD');

    Ext.Ajax.request({
        url: '/UCI/GetFacilitiesWithCustomizedData',
        params: { __RequestVerificationToken: getSiteAntiForgeryTokenValue(), model: mainGrid.table, field: mainGrid.column },
        success: function (response) {
            if (callback)
                callback(response.responseText);
        }
    });
}

EditComboDataDialog = Ext.extend(Ext.Window, {

    id: 'editComboD',
    title: '',
    width: 945,
    height: 480,
    modal: true,
    style: 'z-index: 150;BACKGROUND-COLOR:TRANSPARENT;',
    layout: 'table',
    layoutConfig: {
        rows: 2,
        columns: 2
    },
    iconCls: 'window-icon-default',
    setLinked: function (val) {
        this.HasAlertedLink = true;
        this.shownParentDeleteWarning = true;
        this.IsLinked = val;

        if (val === true) {
            //We are now a linked item.
            this.HasAlertedLink = false;
            this.shownParentDeleteWarning = false;
            Ext.getCmp('linkedMessage').setVisible(true);
        } else {
            //We are no longer a linked item.
            Ext.getCmp('linkedMessage').setVisible(false);
        }
    },
    setDataDirty: function () {
        var self = Ext.getCmp('editComboD');
        self.setIconClass('window-icon-dirty');
        self.isDataDirty = true;
    },
    setAddDeleteDataDirty: function () {
        var self = Ext.getCmp('editComboD');
        self.setIconClass('window-icon-dirty');
        self.isAddDeleteDataDirty = true;
    },
    clearDataDirty: function () {
        var self = Ext.getCmp('editComboD');
        self.setIconClass('window-icon-default');
        self.isDataDirty = false;
        self.isAddDeleteDataDirty = false;
    },
    clearAddDeleteDataDirty: function () {
        var self = Ext.getCmp('editComboD');
        self.isAddDeleteDataDirty = false;
        // We are only clearing the isAddDeleteDataDirty
        // Make sure the icon is still correct
        if (self.isDataDirty)
            self.setIconClass('window-icon-dirty');
        else
            self.setIconClass('window-icon-default');
    },
    initComponent: function () {
        // MTM-4132 this message must be set inside a function to work, and should be done via the JS function
        relationalWarning = ___("WARNING_OTHER_COMBO_BOX_REFERENCE_THIS_THEY_WILL_BE_AFFECTED");

        //This will be set if we are customizing per facility.
        //var FacilityUID = '4CA22A04-0079-4033-84A5-E5968C7F3F17';       // new record uid

        var dlg = this;
        var doSubmit = function (btnConfirm) {

            dlg.WindowManager.SubmitChanges(btnConfirm);
            if (dlg.callback)
                dlg.callback();
        }

        var doSubmitWithPrompt = function () {
            // if "All Facilities" is selected and changes have been made, prompt to have changes made to customized facility lists also
            if (Ext.getCmp('UCIComboSelection').previousState === 0 && Ext.getCmp('editComboD').isAddDeleteDataDirty) {
                getFacilitesWithCustomizedData(function (customizedFacilities) {
                    Ext.MessageBox.confirm(___('ALERT_TITLE'),
                        ___('APPLY_CHANGES_TO_CUSTOM_FACILITY_LISTS_MSG') + "<br /><br />" + ___('CUSTOM_DATA_FACILITIES') + ':<br /><br />' + customizedFacilities,
                        doSubmit);
                    });
            }
            else {
                doSubmit();
            }
        }

        this.title = ___('EDIT_COMBO_DATA');

        this.items =
            [
                //Link message container.
                new Ext.Container({
                    rowspan: 1,
                    colspan: 2,
                    style: 'padding: 5px;background-color: black;',
                    items: [{
                        xtype: 'box',
                        id: 'linkedMessage',
                        hidden: true,
                        style: 'background-color:black;color:white;font-weight: bold;font-family:verdana',
                        html: '<img src="/Content/images/icons/small/lock.png" /> <span style="padding-bottom: 15px"> These Values Are Linked </span>'
                    }]
                }),

                //Customization Option Drop Down
                new Ext.Container({
                    colspan: 1,
                    rowspan: 1,
                    style: 'padding: 5px',
                    items: [{
                        xtype: 'box',
                        html: ___('CUSTOMIZATION_OPTION'),
                        style: 'color: white;font-weight:bold;padding-bottom: 5px'
                    },
                    {
                        xtype: 'combo',
                        id: 'UCIComboSelection',
                        width: 450,
                        autoSelect: false,
                        autoShow: true,
                        editable: false,
                        fieldLabel: ___('CUSTOMIZATION_OPTION'),
                        store: new Ext.data.ArrayStore({
                            autoDestroy: true,
                            autoLoad: true,
                            data: [[___('CUSTOMIZE_FOR_ALL_FACILITIES') + ' '], [___('CUSTOMIZE_FOR') + ' ']],
                            fields: ['option']
                        }),
                        displayField: 'option',
                        typeAhead: false,
                        mode: 'local',
                        triggerAction: 'all',
                        lastQuery: '',
                        listeners: {
                            afterrender: function (a) {
                                var self = Ext.getCmp('UCIComboSelection');
                                self.setValue(self.store.getAt(0).get('option'));
                            },
                            beforequery: function (qe) {
                                delete qe.combo.lastQuery;
                            },
                            select: function (self, record, index) {
                                if (index === self.previousState)
                                    return;

                                var target = Ext.getCmp('editComboD');

                                function Process(btnResult) {

                                    function revertToPreviousState() {
                                        if (self.previousState === undefined)
                                            self.previousState = 0;

                                        self.setValue(self.store.getAt(self.previousState).get('option'));
                                        return;
                                    }

                                    function performAction(btnResult) {
                                        if (btnResult != 'yes') {
                                            revertToPreviousState();
                                            return;
                                        }

                                        if (index === 0) {
                                            // delete all facility-specific records
                                            var grid = Ext.getCmp('UCIExistingData');
                                            grid.store.each(function (record) {
                                                grid.store.remove(record);
                                            });

                                            // switch the dialog callback function temporarily before calling doSubmit()
                                            var oldTargetCallback = target.callback;
                                            target.callback = function () {
                                                Ext.Ajax.request({
                                                    url: '/UCI/GetActiveFacility',
                                                    success: function (response) {
                                                        var thisFacility = response.responseText;

                                                        if (index === 1) {
                                                            target.refresh(thisFacility);
                                                        } else if (index === 0) {
                                                            target.refresh(undefined);
                                                        }
                                                    }
                                                });
                                            }

                                            // save the changes
                                            doSubmit();

                                            // restore original dialog callback
                                            target.callback = oldTargetCallback;
                                        }

                                        self.previousState = index;
                                    }

                                    if (btnResult !== 'yes') {
                                        revertToPreviousState();
                                        return;
                                    }

                                    var message = '';
                                    if (index === 0)
                                        message = ___('REVERT_TO_SHARED_COMBO_VALUES_MSG');
                                    else if (index === 1)
                                        message = ___('CUSTOMIZE_COMBO_VALUES_FOR_THIS_FACILITY_MSG');

                                    Ext.MessageBox.confirm(___('ARE_YOU_SURE'),
                                        message,
                                        performAction);
                                }

                                // check if they realize they will be losing data
                                if (target.isDataDirty) {
                                    Ext.MessageBox.confirm(___('ARE_YOU_SURE'),
                                        ___('ARE_YOU_SURE_WANT_TO_DISCARD_CHANGES_MSG'),
                                        Process);
                                } else {
                                    Process('yes');
                                }
                            }
                        }
                    }]
                }),

                //Link To - Drop Down Box Selector
                new Ext.Container({
                    colspan: 1,
                    rowspan: 1,
                    width: 450,
                    style: 'padding: 5px',
                    items: [
                        {
                            xtype: 'box',
                            html: ___('LINK_VALUES'),
                            style: 'color: white;font-weight: bold;padding-bottom: 5px;'
                        },
                        {
                            xtype: 'combo',
                            id: 'UCIComboLinkSelection',
                            autoSelect: false,
                            autoShow: true,
                            width: 450,
                            style: 'font-size: small',
                            editable: false,
                            fieldLabel: ___('LINK_VALUES'),
                            mode: 'local',
                            store: new Ext.data.XmlStore({
                                id: 'linkValueStore',
                                url: '/UCI/GetListOfComboLink',
                                record: 'Pair',
                                autoLoad: false,
                                fields: ['Model', 'Field', 'Display'],
                                listeners: {
                                    load: function () {
                                        var Self = Ext.getCmp('UCIComboLinkSelection');
                                        var BlankRecord = new Ext.data.Record.create([
                                            { name: 'Model', mapping: 'Model', allowBlank: true },
                                            { name: 'Field', mapping: 'Field', allowBlank: true },
                                            { name: 'Display', mapping: 'Display', allowBlank: false }]);

                                        Self.getStore().insert(0, new BlankRecord({ Model: undefined, Field: undefined, Display: ___('None') }));

                                        // determine whether or not this record is linked and if so - to what.
                                        var self = Ext.getCmp('editComboD');
                                        var linkedStore = new Ext.data.XmlStore({
                                            url: '/UCI/GetComboMetaData',
                                            record: 'A',
                                            fields: ['AModel', 'AField', 'IsParent'],
                                            autoLoad: false,
                                            listeners:
                                            {
                                                load: function (selfStore) {
                                                    var foundMatch = false;
                                                    var isParent = false;

                                                    var DropDown = Ext.getCmp('UCIComboLinkSelection');
                                                    var count = selfStore.getCount();
                                                    if (count > 0) {
                                                        //Then this record is linked to something, so
                                                        //select it in the list.
                                                        var record = selfStore.getAt(0);
                                                        isParent = record.get('IsParent');

                                                        DropDown.getStore().each(function (rec) {
                                                            if (rec.get('Model') == record.get('AModel') &&
                                                                rec.get('Field') == record.get('AField')) {
                                                                DropDown.setValue(rec.get('Display'));
                                                                foundMatch = true;
                                                            }
                                                        });

                                                    }

                                                    Ext.getCmp('editComboD').isParent = isParent;

                                                    if (!foundMatch)
                                                        DropDown.setValue(___('None'));
                                                    else
                                                        Ext.getCmp('editComboD').setLinked(true);
                                                }
                                            }
                                        });

                                        linkedStore.load({ params: { table: self.table, column: self.column } });

                                    }
                                }
                            }),
                            displayField: 'Display',
                            typeAhead: false,
                            triggerAction: 'all',
                            lastQuery: '',
                            listeners: {
                                render: function (omg) {
                                    var Self = Ext.getCmp('editComboD');
                                    this.store.load({ params: { table: Self.table, column: Self.column } });
                                },
                                beforequery: function (qe) {
                                    delete qe.combo.lastQuery;
                                },
                                select: function (self, record, index) {
                                    var target = Ext.getCmp('editComboD');

                                    function Process(btnResult) {
                                        if (btnResult != 'yes') {
                                            if (this.previousState === undefined)
                                                this.previousState = 0;

                                            self.setValue(___('None'));
                                            return;
                                        }

                                        //Hard coding the facility for test purposes.
                                        this.previousState = index;

                                        //Load based on selected item.
                                        if (index !== 0) {
                                            //None -> Linked

                                            Ext.getCmp('editComboD').setLinked(true);

                                            Ext.Ajax.request({
                                                url: '/UCI/AddComboLink',
                                                params: { table: target.table, column: target.column, targetTable: record.get('Model'), targetColumn: record.get('Field') },
                                                success: function (result) {
                                                    if (result.responseText.length != 0) {
                                                        Ext.MessageBox.alert(___('WARNING_TITLE'), result.responseText);
                                                    } else {
                                                        Ext.getCmp('editComboD').refresh(undefined);
                                                    }
                                                }
                                            });
                                        } else {
                                            //Linked -> None

                                            Ext.getCmp('editComboD').setLinked(false);

                                            Ext.Ajax.request({
                                                url: '/UCI/RemoveComboLink',
                                                params: { table: target.table, column: target.column },
                                                success: function (result) {
                                                    Ext.getCmp('editComboD').refresh(undefined);
                                                }
                                            });
                                        }
                                    }

                                    //Check if they realize they will be losing data.
                                    Ext.MessageBox.confirm(___('ARE_YOU_SURE'),
                                        ___('ARE_YOU_SURE_YOU_WISH_TO_LINK_THIS_COMBO_BOX') + ' <br />' + ___('PLEASE_NOTE_THIS_ACTION_CANNOT_BE_UNDONE'),
                                        Process);
                                }
                            }
                        }]
                }),

                new uciGrid({
                    id: 'UCIAvailable',
                    title: ___('AVAILABLE'),
                    store: new Ext.data.XmlStore({
                        url: '/UCI/GetAvailableComboData',
                        record: 'ComboData',
                        fields: ['nUID', 'cValue']
                    }),
                    width: 450,
                    bbar: { // MTM-6048 - Code changes to make 'Available' list searchable
                        style: 'padding-top: 10px',
                        items: [___('FIND') + ':',
                            {
                                id: 'searchField',
                                xtype: 'textfield',
                                width: 420,
                                listeners: {
                                    // Code changes to make 'Available' list searchable
                                    keyup: function () {
                                        var gridAvailable = Ext.getCmp('UCIAvailable');
                                        var searchValue = Ext.getCmp('searchField').getValue();

                                        var highlightRowIndex = 0;
                                        var newRowIndex = 0;
                                        var focusRowIndex = -1;

                                        if (gridAvailable.store.getCount() > 0) {
                                            gridAvailable.store.each(function (rec) {
                                                var row = Ext.getCmp('UCIAvailable').getView().getRow(newRowIndex);
                                                Ext.get(row).setStyle("background-color", "White");
                                                newRowIndex++;
                                            });
                                        }

                                        if (gridAvailable.store.getCount() > 0 && searchValue.toString().trim().length > 0) {
                                            gridAvailable.store.each(function (rec) {
                                                var gridRowValue = rec.get('cValue');
                                                if (gridRowValue.toString().trim().toLowerCase().startsWith(searchValue)) {
                                                    var row = Ext.getCmp('UCIAvailable').getView().getRow(highlightRowIndex);
                                                    Ext.get(row).setStyle("background-color", "#4169E1");
                                                    if (focusRowIndex == -1)
                                                        focusRowIndex = highlightRowIndex;
                                                }
                                                highlightRowIndex++;
                                            });
                                        }

                                        // To have focus on the final search result on the 'Available' list 
                                        if (focusRowIndex > 0)
                                            Ext.getCmp('UCIAvailable').getView().getRow(focusRowIndex).scrollIntoView();

                                        Ext.getCmp('searchField').focus();

                                    },
                                }
                            }
                        ]
                    },
                    //MTM-6048 Ends

                    DeleteFN: function (grid, index) {
                        var array = new Array();
                        var arrayNames = new Array();
                        var records = new Array();

                        grid.selModel.each(function (record) {
                            array.push(record.get('nUID'));
                            arrayNames.push(record.get('cValue'));
                            records.push(record);
                        });

                        Ext.Ajax.request({
                            url: '/UCI/DeleteAvailableComboData',
                            params: {
                                uID: array
                            },
                            success: function (response) {
                                var message = ___("ALL_ITEMS_DELETED_SUCCESSFULLY");
                                var fail = "";

                                var r = 0;
                                var succeded = true;

                                var resultArray = response.responseText.split(',');
                                Ext.each(resultArray, function (val) {
                                    if (val == "0") {
                                        //This item was removed successfully.
                                        grid.store.remove(records[r]);
                                    } else {
                                        succeded = false;
                                        fail += arrayNames[r] + ",";
                                    }
                                    r++;
                                });

                                if (!succeded) {
                                    //There was a problem...
                                    message = (___("FAILED_TO_REMOVE_THESE_ITEMS")).replace("{0}", fail.substr(0, fail.length - 1));
                                }

                                Ext.Msg.show({
                                    title: ___('DELETE_RESULTS'),
                                    msg: message,
                                    width: 300,
                                    icon: Ext.MessageBox.Error,
                                    buttons: Ext.MessageBox.OK
                                });

                                grid.selModel.clearSelections();
                            }
                        });
                    }
                }),

                new uciGrid({
                    id: 'UCIExistingData',
                    title: ___('EXISTING_DATA_FOR'),
                    allowDrop: true,
                    style: 'background-color:transparent;padding: 5px',
                    height: 345,
                    store: new Ext.data.XmlStore({
                        url: '/UCI/GetControlComboData',
                        record: 'Data',
                        handleDataDirty: function (thisStore, records, index) {
                            var isDirty = false;
                            var array = thisStore.loadState;
                            var selfWindow = Ext.getCmp('editComboD');

                            if (array.length != thisStore.getCount()) {
                                isDirty = true;
                                selfWindow.setAddDeleteDataDirty();
                            } else {
                                // A move causes a remove event followed by an add event. The remove event causes the AddDeleteDataDirty
                                // flag to get set because the number of items do not match the original list.
                                // The addition of the item back into the list at the new index causes the lists to be the same length.
                                // 
                                // We only get here is the grid has the same number of items as the initial load items
                                // Now check to see if any item are moved or not in the original load items
                                var addDeleteDataDirty = false;
                                var storeIx = 0;
                                thisStore.each(function (rec) {
                                    var id = rec.get('nUID');
                                    var recFound = false;
                                    var arrayIx = 0
                                    // Check each item in the store vs the store at the time of load
                                    // Dirty flag is set if any items at the same index do not match
                                    // AddDeleteDirty flag is cleared as long as both lists have the same items, no matter the order
                                    array.forEach(function (item) {
                                        if (arrayIx == storeIx && id != item)
                                            isDirty = true;

                                        if (id == item)
                                            recFound = true;

                                        arrayIx++;
                                    });

                                    if (!recFound)
                                        addDeleteDataDirty = true;

                                    storeIx++;
                                });

                                if (!addDeleteDataDirty)
                                    selfWindow.clearAddDeleteDataDirty();
                            }

                            if (isDirty)
                                selfWindow.setDataDirty();
                            else
                                selfWindow.clearDataDirty();
                        },
                        fields: ['nUID', 'cValue', 'lThisFacilityOnly'],
                        listeners: {
                            load: function (thisStore, records) {
                                //Clear the data dirty warning since everything has been reset.	
                                var selfWindow = Ext.getCmp('editComboD');
                                selfWindow.clearDataDirty();

                                //Create a new loadState Object
                                var array = new Array();
                                var recordArray = new Array();
                                selfWindow.ThisFacilityOnly = false;

                                //Add each record to the loadState Object.
                                thisStore.each(function (record) {
                                    array.push(record.get('nUID'));
                                    recordArray.push(record);
                                    selfWindow.ThisFacilityOnly = +record.get('lThisFacilityOnly') !== 0;
                                });

                                thisStore.initialState = recordArray;
                                thisStore.loadState = array;

                                // if the loaded items are for this facility only, 
                                // set the selection drop-down list to "This Facility"
                                var selection = Ext.getCmp('UCIComboSelection');
                                selection.previousState = selfWindow.ThisFacilityOnly ? 1 : 0;
                                selection.setValue(selection.store.getAt(selection.previousState).get('option'));

                            },
                            add: function (thisStore, records, index) {
                                thisStore.handleDataDirty(thisStore, records, index);
                            },
                            remove: function (thisStore, records, index) {
                                thisStore.handleDataDirty(thisStore, records, index);
                            }
                        }
                    }),
                    DeleteFN: function (grid, index) {

                        function Delete() {
                            grid.selModel.each(function (record) {
                                grid.store.remove(record);
                            });
                        }

                        var SelfWindow = Ext.getCmp('editComboD');
                        if (SelfWindow.isParent)
                        {
                            //This is a parent item so don't just delete stuff without warning!

                            Ext.MessageBox.confirm(___("ARE_YOU_SURE"),
                                relationalWarning,
                                function (btn) {
                                    if (btn == "yes") {
                                        Delete();
                                    }
                                });
                        } else {
                            Delete();
                        }
                    },
                    listeners: {
                        render: function (grid) {
                            var ddRow = new Ext.dd.DropTarget(grid.getGridEl(), {
                                ddGroup: 'depGridDD',
                                copy: false,
                                notifyDrop: function (source, event, data) {
                                    var dropIndex = source.getDragData(event).rowIndex;
                                    function Process() {
                                        var OriginID = source.dragData.grid.id;
                                        var TargetID = grid.id;

                                        var TargetGrid = source.dragData.grid;
                                        var records = source.dragData.selections;
                                        
                                        Ext.each(records, function (record) {
                                            // MTM-5715  - Changes to block drag and drop "Closed" item into available list
                                            var newValue = record.get('cValue');
                                            var newValueUpper = newValue.charAt(0).toUpperCase() + newValue.substring(1) // To check for "closed"
                                            if ((columnGlobal == "cCallSheetStatus") && (newValue == ___('Closed') || newValueUpper == ___('Closed'))) {
                                                Ext.Msg.alert(___('attention_title'), ___("CANNOT_ADD_STATUS_CLOSED"));
                                                return;
                                            }
                                            // MTM-5715 Ends

                                            if (source.dragData == undefined)
                                                dropIndex = 0;

                                            if (dropIndex == undefined) {
                                                dropIndex = grid.store.getCount();
                                                if (dropIndex < 0)
                                                    dropIndex = 0;
                                            }

                                            if (OriginID === TargetID) {
                                                //ReArrange	
                                                if (dropIndex > grid.store.getCount() - 1)
                                                    dropIndex--;

                                                TargetGrid.store.remove(record);
                                                TargetGrid.store.insert(dropIndex, record);
                                                dropIndex++;

                                            } else if (OriginID !== TargetID) {
                                                //This is a new item add operation.
                                                var canAdd = true;
                                                var existingIndex = 0;

                                                //Check if the item already exists.
                                                if (grid.store.getCount() > 0) {
                                                    grid.store.each(function (rec) {
                                                        var uid = rec.get('nUID');
                                                        if (uid == record.get('nUID')) {
                                                            canAdd = false;
                                                        }

                                                        if (canAdd)
                                                            existingIndex++;
                                                    });
                                                }

                                                if (canAdd) {
                                                    grid.store.insert(dropIndex, record);
                                                    grid.selModel.selectRow(dropIndex);
                                                } else {
                                                    //alert( "That item already exists in the list." );
                                                    var row = Ext.getCmp('UCIExistingData').getView().getRow(existingIndex);
                                                    var element = Ext.get(row);

                                                    element.fadeOut();
                                                    element.fadeIn();
                                                }
                                            }
                                        });

                                        grid.selModel.clearSelections();
                                        source.dragData.grid.selModel.clearSelections();
                                    }

                                    var SelfWindow = Ext.getCmp('editComboD');

                                    if (SelfWindow.IsLinked === true && !SelfWindow.HasAlertedLink) {
                                        
                                        Ext.MessageBox.confirm(___('ARE_YOU_SURE'),
                                            relationalWarning, function (btnResult) {
                                                if (btnResult == "yes") {
                                                    SelfWindow.HasAlertedLink = true;
                                                    Process();
                                                    return true;
                                                }
                                                return false;
                                            });
                                    } else {
                                        Process();
                                    }

                                    return true;
                                }
                            });
                            return true;
                        }
                    },
                    loadValues: function (a, b, c) {
                        this.store.load({ params: { table: a, column: b, facilityUID: c } });
                    }
                })

            ];

        this.bbar = {
            xtype: 'toolbar',
            items:
                [
                    {
                        xtype: 'tbfill'
                    },
                    {
                        xtype: 'button',                        
                        iconCls: 'btn-modify2-sm',
                        tooltip: ___('CUSTOM_FACILITY_DATA'),
                        handler: function () {
                            getFacilitesWithCustomizedData(function (customizedFacilities) {
                                Ext.MessageBox.alert(___('FACILITIES'), ___('CUSTOM_DATA_FACILITIES') + ': <br /> <br />' + customizedFacilities);
                            });
                        }
                    },
                    { xtype: 'tbspacer', width: 15 },
                    {
                        xtype: 'button',
                        text: ___('SAVE'),
                        tooltip: ___('SAVE'),
                        handler: doSubmitWithPrompt
                    },
                    { xtype: 'tbspacer', width: 15 },
                    {
                        xtype: 'button',
                        text: ___('CANCEL'),
                        tooltip: ___('CANCEL'),
                        handler: function () {
                            if (!Ext.getCmp('editComboD').isDataDirty)
                                dlg.close();
                            else {
                                Ext.MessageBox.confirm(___('ARE_YOU_SURE'),
                                    ___('CONFIRM_DISCARD_CHANGES'),
                                    function (btnResult) {
                                        if (btnResult != 'yes')
                                            return;

                                        var grid = Ext.getCmp('UCIExistingData');
                                        grid.store.removeAll();

                                        Ext.each(grid.store.initialState, function (record) {
                                            grid.store.add(record);
                                        });

                                        //Clear the data dirty warning since everything has been reset.	
                                        var selfWindow = Ext.getCmp('editComboD');
                                        selfWindow.clearDataDirty();
                                    });
                            }
                        }
                    },
                    { xtype: 'tbspacer', width: 10 }
                ]
        };

        EditComboDataDialog.superclass.initComponent.call(this);
    },
    load: function (table, column, callback, facilityUID, facilityName) {

        if (facilityUID != undefined)
            this.FacilityUID = facilityUID;
        else
            this.FacilityUID = null;

        // this code identifies the text to use in the Customization Option drop-down list item
        // and updates the item with the facility name
        // however, we currently never pass a facility name into this function!
        // leaving the code here for potential future use
        var fName = ___("THIS_FACILITY");
        if (facilityName !== undefined)
            fName = ___("FACILITY") + " - " + facilityName;
        this.facilityName = fName;

        var selection = Ext.getCmp('UCIComboSelection');
        selection.store.each(function (rec) {
            var current = rec.get('option');
            current = current.replace("{0}", fName);
            rec.set('option', current);
        });

        this.table = table;
        this.column = column;
        this.callback = callback;

        //MTM-5715 - Storing columnName in the global variable
        columnGlobal = column;
        tableGlobal = table;
        // MTM-5715 Ends

        // load all lists on the dialog and update the labels with the column name
        this.items.each(function (item) {
            if (item.store !== undefined)
                item.loadValues(table, column, facilityUID);

            if (item.title !== undefined)
                item.title = item.title.replace("{0}", column);
        });

        this.WindowManager = {
            table: table,
            column: column,
            SubmitChanges: function (updateAllCustomFacilityLists) {
                var doSave = true;
                var uidArray = new Array();
                Ext.getCmp('UCIExistingData').store.each(function (record) {
                    // Disallow saving this on the CallsheetLog if it's got a Closed
                    var table = tableGlobal || '';
                    if (table == "CallSheetLog" && columnGlobal == "cStatus") {
                        if (record.get('cValue').toString().toLowerCase() == "closed") {
                            doSave = false;
                            return;
                        }
                    }

                    uidArray.push(record.get('nUID'));
                });

                if (!doSave) {
                    Ext.Msg.alert(___('attention_title'), ___("CANNOT_ADD_STATUS_CLOSED"));
                    return;
                }

                var facUid = Ext.getCmp('UCIComboSelection').previousState == 0 ? null : facilityUID;

                Ext.Ajax.request({
                    url: '/UCI/SubmitComboDataChanges',
                    params: { table: table, column: column, UIDs: uidArray, facilityUID: facUid, updateAllCustomFacilityLists: (updateAllCustomFacilityLists == 'yes') },
                    success: function () {
                        var targetGrid = Ext.getCmp('UCIExistingData');
                        targetGrid.store.removeAll();
                        targetGrid.loadValues(table, column, facilityUID);
                    }
                });
            }
        };

        Ext.override(Ext.dd.DDProxy, {
            onDrag: function (event) {
                var dragEl = Ext.get(this.getDragEl());
                dragEl.applyStyles({ border: 'solid 1px black', 'font-family': 'verdana', 'color': 'white', 'z-index': 9999999 });
                return true;
            }
        });

        //Show the dialog window.  
        this.show();
    },
    refresh: function (facilityUID) {
        Ext.getCmp('editComboD').load(this.table, this.column, this.callback, facilityUID);
    }
});
